function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M30.4,4.54747351e-12 L82.6,4.54747351e-12 C85.0300529,4.54702712e-12 87,1.96994709 87,4.39999998 L87,89.6 C87,92.0300529 85.0300529,94 82.6,94 L30.4,94 C27.9699471,94 26,92.0300529 26,89.6 L26,4.39999998 C26,1.96994709 27.9699471,4.5479199e-12 30.4,4.54747351e-12 Z",
  id: "path-1-pdrLeft"
}), React.createElement("filter", {
  x: "-54.1%",
  y: "-35.1%",
  width: "208.2%",
  height: "170.2%",
  filterUnits: "objectBoundingBox",
  id: "filter-2-pdrLeft"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 11,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.316471554   0 0 0 0 0.506602588   0 0 0 0 0.728289753  0 0 0 0.246773098 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), React.createElement("linearGradient", {
  x1: "48.5130383%",
  y1: "24.5627858%",
  x2: "54.2406414%",
  y2: "129.806096%",
  id: "linearGradient-3-pdrLeft"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  stopOpacity: 0.989470109,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})), React.createElement("path", {
  d: "M4.39999998,0 L17.1599999,0 C19.5900528,-2.60471401e-15 21.5599999,1.96994709 21.5599999,4.39999998 L21.5599999,89.6 C21.5599999,92.0300529 19.5900528,94 17.1599999,94 L4.39999998,94 C1.96994709,94 -5.90582771e-16,92.0300529 -1.77635684e-15,89.6 L-1.77635684e-15,4.39999998 C-2.07395249e-15,1.96994709 1.96994709,4.46393473e-16 4.39999998,0 Z",
  id: "path-4-pdrLeft"
}), React.createElement("filter", {
  x: "-153.1%",
  y: "-35.1%",
  width: "406.1%",
  height: "170.2%",
  filterUnits: "objectBoundingBox",
  id: "filter-5-pdrLeft"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 11,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.316471554   0 0 0 0 0.506602588   0 0 0 0 0.728289753  0 0 0 0.246773098 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-pdrLeft",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "21-desktop-UI-pdrLeft",
  transform: "translate(-851.000000, -315.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-18-pdrLeft",
  transform: "translate(420.000000, 157.000000)"
}, React.createElement("g", {
  id: "Group-7-pdrLeft",
  transform: "translate(453.000000, 180.000000)"
}, React.createElement("g", {
  id: "Rectangle-14-pdrLeft",
  transform: "translate(56.500000, 47.000000) rotate(-180.000000) translate(-56.500000, -47.000000) "
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2-pdrLeft)",
  xlinkHref: "#path-1-pdrLeft"
}), React.createElement("use", {
  fill: "#FFFFFF",
  xlinkHref: "#path-1-pdrLeft"
})), React.createElement("g", {
  id: "Rectangle-14-pdrLeft",
  transform: "translate(10.780000, 47.000000) rotate(-180.000000) translate(-10.780000, -47.000000) "
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-5-pdrLeft)",
  xlinkHref: "#path-4-pdrLeft"
}), React.createElement("use", {
  fill: "url(#linearGradient-3-pdrLeft)",
  xlinkHref: "#path-4-pdrLeft"
}))))));

var SvgPdrLeft = function SvgPdrLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "131px",
    height: "138px",
    viewBox: "0 0 131 138",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdrLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdrLeft.1ef4b62b.svg";
export { ForwardRef as ReactComponent };